import { useEffect, useState } from 'react';
import { AlertCircle, CheckCircle, Upload, XCircle } from 'react-feather';
import { useRemote } from '../../../Utils/Utils';
import { useUploadWithConfirmation } from './DataUploadWithConfirmation';
import Tooltip from '../../../components/popups/Tooltip';
import Checkbox from '../../../components/Checkbox';
import DataUploadFileName from './DataUploadFileName';
import TextInput from '../../../components/Input/TextInput';
import Button from '../../../components/Buttons/Button';
import LoadingIcon from '../../../components/LoadingIcon';
import "./DataManagerPage.scss";
import { fi } from 'date-fns/locale';


const DataUploadExpandedRow = ({ upload, batchIndex, reupload, openDialog, openPasswordDialog }) => {
    const remote = useRemote()
    const expandedColWidths = ["auto", "100px", "80px", "440px"]
    const { lastBatchWithEncryptedFiles, setLastBatchWithEncryptedFiles } = useUploadWithConfirmation()
    const [files, setFiles] = useState(null)
    const [filters, setFilters] = useState(['FAILED', 'COMPLETED', "ON_HOLD", "CANCELLED"])
    const [passwords, setPasswords] = useState(null)
    const [invalidPasswords, setInvalidPasswords] = useState(null)
    const [unlocking, setUnlocking] = useState(null)

    useEffect(() => {
        setFiles(upload.uploadedFiles)
        setPasswords(upload.uploadedFiles.filter(f => f.status === 'ENCRYPTED').reduce((acc, f) => { acc[f.id] = { id: f.id, password: '' }; return acc; }, {}))
        setInvalidPasswords(upload.uploadedFiles.filter(f => f.status === 'ENCRYPTED').reduce((acc, f) => { acc[f.id] = { id: f.id, invalid: false }; return acc; }, {}))

        if (lastBatchWithEncryptedFiles && lastBatchWithEncryptedFiles.batchId === upload.batchId) {
            setPasswords(lastBatchWithEncryptedFiles.uploadedFiles.filter(f => f.status === 'ENCRYPTED').reduce((acc, f) => { acc[f.id ? f.id : f.fileId] = { id: f.id ? f.id : f.fileId, password: f.password ? f.password : '' }; return acc; }, {}))
            setInvalidPasswords(lastBatchWithEncryptedFiles.uploadedFiles.filter(f => f.status === 'ENCRYPTED').reduce((acc, f) => { acc[f.id ? f.id : f.fileId] = { id: f.id ? f.id : f.fileId, invalid: f.password ? true : false }; return acc; }, {}))
        }
    }, [upload, lastBatchWithEncryptedFiles])

    useEffect(() => {
        return () => {
            setLastBatchWithEncryptedFiles(null)
        };
    }, []);


    function getStatus(status, upload, file) {
        switch (status) {
            case 'PROCESSING':
            case 'PENDING':
                return <Upload size={20} color='#0E8EFD' />
            case 'COMPLETED':
                if (file.realStatus && file.realStatus === 'PENDING') {
                    return <LoadingIcon size={20} />
                } else {
                    return <CheckCircle size={20} color={"#56D1C3"} />
                }
            case 'ON_HOLD':
                return <AlertCircle size={20} color={"#E66780"} style={{ cursor: 'pointer' }} onClick={(e) => openDialog(e, upload)} />
            case 'ENCRYPTED':
                return <AlertCircle size={20} color={"#E66780"} style={{ cursor: 'pointer' }} onClick={(e) => openPasswordDialog(e, upload, file)} />
            case 'FAILED':
                return <AlertCircle size={20} color={"#E66780"} />
            case 'CANCELLED':
                return <XCircle size={20} color={"#E66780"} />
            default:
                return <AlertCircle size={20} color={"#E66780"} />
        }
    }

    function handleSendPassword(password, currentBatch, file) {
        const fileId = file.fileId ? file.fileId : file.id;
        setUnlocking(fileId);
        const dto = {
            batchId: currentBatch.batchId,
            fileId: fileId,
            password: password.password,
            confirm: true
        }
        remote.post(`/data/upload/resume/${currentBatch.batchId}/decrypt`, [dto]).then(resp => {
            const updatedFileArray = resp.data["PENDING"] || resp.data["COMPLETED"] || resp.data["FAILED"] || resp.data["ENCRYPTED"];
            const updatedFile = { ...updatedFileArray[0], password: password };

            currentBatch.uploadedFiles.map(f => {
                if (f.fileId ? f.fileId === updatedFile.fileId : f.id === updatedFile.fileId) {
                    if (updatedFile.status === 'ENCRYPTED') {
                        const updatedFiles = files.map(f => {
                            if (f.fileId ? f.fileId === updatedFile.fileId : f.id === updatedFile.fileId) {
                                const updatedFileWithPassword = { ...updatedFile, password: password.password };
                                return updatedFileWithPassword;
                            } else return f;
                        })
                        setLastBatchWithEncryptedFiles({ ...currentBatch, uploadedFiles: updatedFiles });
                        setUnlocking(null);
                    } else {
                        setFiles(files.map(file => (file.fileId ? file.fileId === updatedFile.fileId : file.id === updatedFile.fileId) ? { ...updatedFile, status: updatedFile.status === 'PENDING' ? 'COMPLETED' : updatedFile.status, realStatus: updatedFile.status } : file));
                        setUnlocking(null);
                    }
                }
            });
        })
    };

    function handleCancelOneFileUpload(currentBatch, file) {
        const dto = {
            batchId: currentBatch.batchId,
            fileId: file.fileId ? file.fileId : file.id,
            password: null,
            confirm: false
        }
        remote.post(`/data/upload/resume/${currentBatch.batchId}/decrypt`, [dto]).then(resp => {
            const updatedFileArray = resp.data["DELETED"];
            const updatedFile = updatedFileArray && updatedFileArray.length > 0 ? updatedFileArray[0] : null
            if (updatedFile) {
                currentBatch.uploadedFiles.map(f => {
                    if (f.fileId ? f.fileId === updatedFile.fileId : f.id === updatedFile.fileId) {
                        setFiles(files.map(file => (file.fileId ? file.fileId === updatedFile.fileId : file.id === updatedFile.fileId) ? updatedFile : file));
                    }
                });
            }
        })
    };

    return (
        <tr>
            <td colspan='11' style={{ backgroundColor: '#FBFBFD', padding: '0 0 1rem' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '153px 1fr' }}>
                    <div style={{ margin: '32px 1.5rem 1rem 0', padding: '0 1rem 1rem', borderRight: 'solid 1px #E7EAF2' }}>
                        <div style={{ fontSize: '0.85rem', fontWeight: 500, padding: '0 0 1.5rem' }}>Filters</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            <Checkbox
                                checked={filters.includes('COMPLETED')}
                                label={<div style={{ fontSize: '0.9rem' }}>Success</div>}
                                onChange={() => setFilters(filters.includes('COMPLETED') ? filters.length === 1 ? ['FAILED'] : filters.filter(f => f !== 'COMPLETED') : [...filters, 'COMPLETED'])}
                            />
                            <Checkbox
                                checked={filters.includes('FAILED')}
                                label={<div style={{ fontSize: '0.9rem' }}>Failure</div>}
                                onChange={() => setFilters(filters.includes('FAILED') ? filters.length === 1 ? ['COMPLETED'] : filters.filter(f => f !== 'FAILED') : [...filters, 'FAILED'])}
                            />
                            <Checkbox
                                checked={filters.includes('ON_HOLD')}
                                label={<div style={{ fontSize: '0.9rem' }}>On Hold</div>}
                                onChange={() => setFilters(filters.includes('ON_HOLD') ? filters.length === 1 ? ['COMPLETED'] : filters.filter(f => f !== 'ON_HOLD') : [...filters, 'ON_HOLD'])}
                            />
                            <Checkbox
                                checked={filters.includes('CANCELLED')}
                                label={<div style={{ fontSize: '0.9rem' }}>Cancelled</div>}
                                onChange={() => setFilters(filters.includes('CANCELLED') ? filters.length === 1 ? ['COMPLETED'] : filters.filter(f => f !== 'CANCELLED') : [...filters, 'CANCELLED'])}
                            />
                        </div>
                    </div>
                    <table>
                        <colgroup>
                            {expandedColWidths.map((width, idx) => (
                                <col key={"col-" + idx} span="1" style={{ width }} />
                            ))}
                        </colgroup>
                        <thead>
                            <tr>
                                <th className="nested-table-empty-th small"><div className="nested-table-div-in-td no-top">File Name</div></th>
                                <th className="nested-table-empty-th small text-align-right"><div className="nested-table-div-in-td no-top pr-m">Coverage</div></th>
                                <th className="nested-table-empty-th small text-align-center"><div className="nested-table-div-in-td no-top pr-m">Status</div></th>
                                <th className="nested-table-empty-th small"><div className="nested-table-div-in-td no-top align-items-center justify-content-between">Message</div></th>
                                <th className="nested-table-empty-th small" style={{ width: 24 }}><div className="nested-table-div-in-td no-top"></div></th>
                            </tr>
                        </thead>
                        <tbody>
                            {files && files.map((file, index) => {
                                if ((filters.includes(file.status)) || filters.length === 0 || (file.status === 'ENCRYPTED' && filters.includes('ON_HOLD'))) {
                                    const errorMessage = invalidPasswords[file.id] && invalidPasswords[file.id].invalid ? "Invalid password provided." : null
                                    return (
                                        <tr key={file.fileName + "-expanded-" + index}>
                                            <td className="nested-table-empty-td baseline border-top" >
                                                <div style={{ height: file.status === 'ENCRYPTED' ? 130 : 39, maxWidth: 'calc(100% - 1rem)', overflowY: 'hidden' }} className="nested-table-div-in-td no-top pr-l">
                                                    <DataUploadFileName upload={upload} reupload={reupload} file={file} batchIndex={batchIndex} />
                                                </div>
                                            </td>
                                            <td className="nested-table-empty-td baseline border-top text-align-right">
                                                <div style={{ height: file.status === 'ENCRYPTED' ? 130 : 39 }} className="nested-table-div-in-td no-top pr-m">
                                                    <Tooltip disabled={file?.fundsCovered?.length === 0} label={file?.fundsCovered?.map(fund => <div style={{ lineHeight: 1.5 }}>{fund}</div>)}>{file.fundsCovered?.length}</Tooltip>
                                                </div>
                                            </td>
                                            <td className="nested-table-empty-td baseline border-top" key={index}>
                                                <div className="nested-table-div-in-td no-top text-align-center pr-m" style={{ padding: '9px 12px 9px 0px', height: file.status === 'ENCRYPTED' ? 130 : 39, transform: 'translateY(6px)' }}>{getStatus(file.status, upload, file)}</div>
                                            </td>
                                            <td className="nested-table-empty-td baseline border-top">
                                                {file.status === 'ENCRYPTED'
                                                    ? <div style={{ height: file.status === 'ENCRYPTED' ? 130 : 39 }} className="nested-table-div-in-td no-top">
                                                        <div className='flex-align-center gap-s' style={{ height: errorMessage ? 47 : 32, alignItems: 'baseline' }}>
                                                            <div style={{ fontWeight: 500 }}>File encrypted:</div>
                                                            <TextInput
                                                                inputstyle={{ maxWidth: 240 }}
                                                                value={passwords[file.id]?.password || ''}
                                                                onChange={e => {
                                                                    if (e.target.value.length === 0 && invalidPasswords[file.id] && invalidPasswords[file.id].invalid) {
                                                                        setInvalidPasswords({ ...invalidPasswords, [file.id]: { id: file.id, invalid: false } });
                                                                    }
                                                                    setPasswords({ ...passwords, [file.id]: { ...passwords[file.id], password: e.target.value } })
                                                                }}
                                                                eyeIconStyle={{ top: '-1.5rem', left: 'calc(240px - 1.5rem)' }}
                                                                showPasswordToggle={file.status === 'ENCRYPTED'}
                                                                style={{ height: 32 }}
                                                                helperText={errorMessage}
                                                                helperTextClass="invalid-message negative-top"
                                                                invalid={!!errorMessage}
                                                                size="small"
                                                                width="m"
                                                                type="text"
                                                                placeHolder="File password"
                                                                autoComplete="off"
                                                                data-lpignore="true"
                                                                data-form-type="other"
                                                                disabled={unlocking === (file.id ? file.id : file.fileId)}
                                                                onKeyDown={(e) => { if (e.key === 'Enter' && passwords[file.id]?.password) { handleSendPassword(passwords[file.id], upload, file) } }}
                                                            />
                                                        </div>
                                                        <div className='flex-align-center gap-s' style={{ marginTop: '1.25rem' }}>
                                                            <Button disabled={passwords[file.id]?.password === '' || unlocking === (file.id ? file.id : file.fileId)} onClick={() => handleSendPassword(passwords[file.id], upload, file)}>Unlock</Button>
                                                            <Button disabled={unlocking === (file.id ? file.id : file.fileId)} variant="danger" onClick={() => handleCancelOneFileUpload(upload, file)}>Remove File</Button>
                                                        </div>
                                                    </div>
                                                    : <div style={{ height: 39 }} className="nested-table-div-in-td no-top">
                                                        {file.errorMessage}
                                                    </div>
                                                }
                                            </td>
                                            <td className="nested-table-empty-td baseline" style={{ width: '1.5rem' }}></td>
                                        </tr>)
                                } else return ""
                            }
                            )}
                        </tbody>
                    </table>
                </div>
            </td>
        </tr >
    )
}

export default DataUploadExpandedRow